import { render, staticRenderFns } from "./SubjectCard.vue?vue&type=template&id=89959ae6&"
import script from "./SubjectCard.vue?vue&type=script&setup=true&lang=js&"
export * from "./SubjectCard.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports